import {useCallback} from 'react';
import {useIsPlaying} from '../hooks/usePlayerState';
import {usePlayerContext} from './usePlayerContext';

/**
 * Handles toggling the playback of the player. There are a variety of edge cases which this
 * function will abstact away from the UI components that trigger a change in playback status.
 * For now, this simply checks if the player is in playing state, and calls the appropriate
 * method on the player.
 *
 * @returns () => void | a handler for toggling playback
 */
export const usePlaybackToggle = (): (() => void) => {
  const {player} = usePlayerContext();
  const isPlaying = useIsPlaying();

  const onToggle = useCallback(() => {
    if (!player) return;

    if (!isPlaying) {
      player.play('ui');
    } else {
      player.pause('ui');
    }
  }, [player, isPlaying]);

  return onToggle;
};
